import * as React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Box, Flex, useResponsive } from '@ghq-abi/design-system';

import { useAbility } from '~/app/contexts/AbilityContext';
import { useFlags } from '~/app/contexts/FlagsContext';

import oneverseUpdatedLogo from '~/../public/img/one_verse_updated_logo.png';
import oneverseLogo from '~/../public/img/oneverse_logo.png';

import { MobileMenu } from '../Nav/components/MobileMenu';

import { StyledActionWrapper } from './styles';

type HomeLinkProps = {
    children: React.ReactNode;
};

function HomeLink({ children }: HomeLinkProps) {
    const flags = useFlags();

    const href = React.useMemo(() => {
        if (flags.home.active) {
            return '/home';
        }

        return null;
    }, [flags.home.active]);

    return href ? (
        <Link href={href} title="Navigate to home">
            {children}
        </Link>
    ) : (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>{children}</>
    );
}

export function HeaderActions() {
    const ability = useAbility();

    const { isMobile } = useResponsive({ useOnlyAbiTokens: true });

    const { isTablet } = useResponsive({ useOnlyAbiTokens: true });

    const LogoContainer = ability.can('view', 'Home') ? HomeLink : React.Fragment;

    return (
        <StyledActionWrapper>
            {(isTablet || isMobile) && <MobileMenu />}
            <LogoContainer>
                <Flex
                    align="center"
                    gap="sm"
                    css={{ textDecoration: 'none' }}
                >
                    <Box
                        css={{
                            fontSize: 0,
                        }}
                    >
                        <Image
                            src={oneverseUpdatedLogo}
                            alt="Ab InBev"
                            placeholder="blur"
                            width={100}
                        />
                    </Box>
                    <Box
                        css={{
                            display: 'none',
                            '@lg': { display: 'block' },
                            fontSize: 0,
                        }}
                    >
                        <Image src={oneverseLogo} alt="Ab InBev" placeholder="blur" />
                    </Box>
                </Flex>
            </LogoContainer>
        </StyledActionWrapper>
    );
}
